import { ReactElement } from 'react';

export enum NotificationVariants {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
}

export enum NotificationAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export interface NotificationProps {
  autoClose?: boolean;
  banner?: boolean;
  css?: object;
  description?: string | ReactElement;
  id?: number;
  textAlign?: NotificationAlignment;
  title: string;
  variant: NotificationVariants;
}
